import React, { useState } from 'react';
import './RefundComponent.css';
import ENDPOINTS from '../Constants/ApiEndpoints';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from '../UserAccounts/AuthProvider';

const RefundComponent = ({ invoice, onClose, onSubmit }) => {
  const [paymentMode, setPaymentMode] = useState('CASH');
  const [amount, setAmount] = useState('');
  const [refundReason, setRefundReason] = useState('');
  const [transactionId, setTransactionId] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [cardType, setCardType] = useState('');
  const [bank, setBank] = useState('');
  const [loading, setLoading] = useState(false);

    const { userData } = useAuth();

  const maxRefundable = invoice?.amountPaid || 0;

  const handleSubmit = async () => {
    const refundAmount = parseFloat(amount);

    if (!amount || refundAmount <= 0) {
      toast.error('Amount must be a positive number');
      return;
    }

    if (refundAmount > maxRefundable) {
      toast.error(`Refund amount cannot exceed paid amount (₹${maxRefundable})`);
      return;
    }

    if (!refundReason.trim()) {
      toast.error('Please provide a reason for the refund');
      return;
    }
  
    setLoading(true);
  
    try {
      const response = await axios.post(
        `${ENDPOINTS.PROCESS_REFUND}/${invoice.invoiceId}/refund`,
        null,
        {
          params: {
            amount: refundAmount,
            paymentMode,
            refundReason: refundReason.trim(),
            refundedBy: userData.username
          }
        }
      );
  
      toast.success('✅ Refund successful!');
      onSubmit(); // notify parent to refresh data
      onClose();  // close popup
    } catch (error) {
      console.error('Refund failed:', error);
      const errorMsg = error.response?.data?.message || error.response?.data || 'Refund submission failed.';
      toast.error(`❌ ${errorMsg}`);
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div className="payment-popup-overlay">
      <div className="payment-popup">
        <h3>Process Refund</h3>

        <p style={{ fontSize: '0.9em', color: '#666', marginBottom: '10px' }}>
          Max refundable: <strong>₹{maxRefundable}</strong>
        </p>

        <label><strong>Refund Mode:</strong></label>
        <div className="radio-group">
          {['CASH', 'UPI', 'CARD'].map((mode) => (
            <label key={mode} className="radio-option">
              <input
                type="radio"
                value={mode}
                checked={paymentMode === mode}
                onChange={(e) => setPaymentMode(e.target.value)}
              />
              {mode}
            </label>
          ))}
        </div>

        <label>Refund Amount:</label>
        <input
          type="number"
          value={amount}
          max={maxRefundable}
          onChange={(e) => setAmount(e.target.value)}
        />

        <label>Refund Reason: <span style={{color: 'red'}}>*</span></label>
        <input
          type="text"
          value={refundReason}
          placeholder="e.g., Doctor consultation refund"
          onChange={(e) => setRefundReason(e.target.value)}
        />

        {paymentMode === 'UPI' && (
          <>
            <label>Transaction ID:</label>
            <input
              type="text"
              value={transactionId}
              onChange={(e) => setTransactionId(e.target.value)}
            />
          </>
        )}

        {paymentMode === 'CARD' && (
          <>
            <label>Card Number:</label>
            <input
              type="text"
              value={cardNumber}
              onChange={(e) => setCardNumber(e.target.value)}
            />

            <label>Card Type:</label>
            <select
              value={cardType}
              onChange={(e) => setCardType(e.target.value)}
            >
              <option value="">Select</option>
              <option value="Visa">Visa</option>
              <option value="MasterCard">MasterCard</option>
              <option value="RuPay">RuPay</option>
            </select>

            <label>Bank:</label>
            <input
              type="text"
              value={bank}
              onChange={(e) => setBank(e.target.value)}
            />
          </>
        )}

        <div className="popup-actions">
          <button onClick={handleSubmit} disabled={loading}>
            {loading ? 'Processing...' : 'Submit Refund'}
          </button>
          <button onClick={onClose} disabled={loading}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default RefundComponent;

